import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Modal,
} from 'reactstrap';

import OrderForm from './OrderForm';

function OrderModal(props) {
  const { shown, t, item } = props;

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setModalOpen(shown);
  }, [item, shown]);

  const onSuccess = (x) => {
    setModalOpen(false);
    props.onSuccess(x);
  };

  const onCancel = () => {
    setModalOpen(false);
    props.onCancel();
  };

  const jsx = (
    <Modal
      size="xl"
      isOpen={modalOpen}
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          id="myLargeModalLabel"
        >
          {t('Save Order')}
        </h5>
        <button
          onClick={() => { onCancel(); }}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <OrderForm actionUrl="/api/sourcing/orders" entity={item} onSuccess={onSuccess} />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          onClick={() => { onCancel(); }}
          className="btn btn-soft-dark"
          data-dismiss="modal"
        >
          {t('Cancel')}
        </button>
        <button
          type="submit"
          form="OrderEditForm"
          className="btn btn-primary"
        >
          {t('Save Changes')}
        </button>
      </div>
    </Modal>
  );

  return jsx;
}

OrderModal.defaultProps = {
  shown: false,
  item: {},
  onSuccess: () => { },
  onCancel: () => { },
};

OrderModal.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  item: PropTypes.object,
  shown: PropTypes.bool,
  onSuccess: PropTypes.func,
  onCancel: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(OrderModal));
